import { Flex } from "antd";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants";
import { EmptyPoints } from "@/domains/point";
import { BaseButton } from "@/shared/ui";

const EMPTY_MANAGER_MESSAGE =
    "Ви ще не завантажили робочий план жодного співробітника. Перейдіть до розділу команди та оберіть працівника, щоб розпочати роботу з його маршрутом.";

export const ManagerEmptyStateBlock = () => {
    const navigate = useNavigate();

    const handleNavigateToTeam = useCallback(() => {
        navigate(ROUTES.Team);
    }, [navigate]);

    return (
        <Flex vertical>
            <EmptyPoints text={EMPTY_MANAGER_MESSAGE} />

            <BaseButton type="primary" onClick={handleNavigateToTeam}>
                Відкрити список команди
            </BaseButton>
        </Flex>
    );
};
